



































































































import { Vue, Component, Prop, Emit, Watch, Mixins } from "vue-property-decorator";
import { namespace } from "vuex-class";

import moment from "moment";

import { validationMixin, Validation } from "vuelidate";
import { required, helpers } from "vuelidate/lib/validators";

import deviceSearchMixin from "@/components/video-reporting/deviceSearchMixin";

import { Select } from "@sureview/vuejs-sv-dropdown";
import DatePicker from "@sureview/vuejs-datepicker";

import EditableTableData from "@/components/table/EditableTableData.vue";
import { DeviceSearchResult } from "@/store/devices/types";

import { validTime, maxDate, minDate } from "@/mixins/DateValidators";
import { ValidationProperties, ValidationEvaluation } from "vue/types/vue";
import { DeviceSearchModel, VideoReportRequest } from "../../store/video-reporting/types";

@Component({
	components: {
		"editable-td": EditableTableData,
		"sv-select": Select,
		"date-picker": DatePicker
	},
	filters: {
		formatDate: function(date) {
			return moment(date).format("MM/DD/YYYY HH:mm:ss");
		}
	},
	validations: {
		newDateTime: {
			date: {
				required,
				minDate: minDate(new Date(2016, 1, 1)), // Arbitrary minimum date
				maxDate: maxDate(new Date().setHours(23, 59, 59))
			},
			time: {
				required,
				validTime
			}
		}
	}
})
export default class BulkDeviceSearchRow extends Mixins(validationMixin, deviceSearchMixin) {
	@Prop({ type: Object, default: () => {} }) private value: DeviceSearchModel;
	@Prop({ type: Object }) private rowValidation: Validation &
		ValidationProperties<DeviceSearchModel> &
		ValidationEvaluation;
	@Prop({ type: Object }) private videoReportRequest: VideoReportRequest;

	private newDateTime: { date: Date; time: string } = {
		date: null,
		time: ""
	};

	/**
	 * Returns true if we have a valid date.
	 */
	private get isDateValid() {
		return !this.rowValidation.date.$error;
	}

	/**
	 * Returns true if we have a device ID.
	 */
	private get isDeviceValid() {
		return !this.rowValidation.deviceId.$error;
	}

	/**
	 * Returns true if this bulk search record includes device search results.
	 */
	private get hasSearchResults() {
		return this.value.searchResults && this.value.searchResults.length > 0;
	}

	@Emit("input")
	private onInput(newValue: DeviceSearchModel) {}

	@Watch("value", { immediate: true })
	private onValueChanged(newValue: DeviceSearchModel) {
		this.resetDeviceSearches();
	}

	private created() {
		this.$v.$touch();
	}

	private resetDeviceSearches() {
		this.devices = this.value.searchResults;
	}

	private async onDeviceSelected(device: DeviceSearchResult, finishEdit: Function) {
		let { deviceId, deviceTypeId, title } = device;

		this.onInput({
			...this.value,
			deviceId,
			deviceTypeId,
			title
		});

		// $nextTick and then finishEdit as we want to make sure the dropdown has closed
		// otherwise we get into a situation where the <sv-select> has been destroyed,
		// but the dropdown hasn't been closed and ends up without a parent.
		await this.$nextTick();

		finishEdit();
	}

	public onDateSelected(date: Date) {
		this.newDateTime.date = date;
		this.$v.newDateTime.date.$touch();
	}

	private onTimeChanged(time: string) {
		this.newDateTime.time = time;
		this.$v.newDateTime.time.$touch();
	}

	private saveDate(finishEdit: Function) {
		if (!this.$v.newDateTime.$error) {
			let [hours, minutes, seconds] = this.newDateTime.time.split(":");
			let newDate = moment(this.newDateTime.date)
				.set({
					hours: parseInt(hours),
					minutes: parseInt(minutes),
					seconds: parseInt(seconds)
				})
				.toDate();

			this.onInput({
				...this.value,
				date: newDate
			});

			finishEdit();
		}
	}
}
